import { useContext } from 'react'
import { State, ActiveText } from '../utils/context'
import Button from '../components/button'
import ArrowLeft from '../icons/arrow-left'
import ArrowRight from '../icons/arrow-right'
import Copy from '../icons/copy'
import Share from '../icons/share'
import Search from '../icons/search'
import Book from '../icons/book'
import styles from './buttons.module.css'

const Buttons = () => {
  const [{input, chapters, status, active}, setState] = useContext(State)
  const activeText = useContext(ActiveText)

  const onChange = value => setState(state => ({
    ...state, 
    input: {
      ...state.input,
      chapter: state.input.chapter + value
    }
  }))

  const onClick = () => {
    navigator.share
      ? navigator.share({text: activeText}).then(() => setState(state => ({
        ...state,
        active: {
          ...state.active,
          verses: {}
        }
      }))).catch(() => {})
      : navigator.clipboard?.writeText(activeText).then(() => setState(state => ({
        ...state,
        active: {
          ...state.active,
          verses: {}
        }
      }))).catch(() => {})
  }

  // Fokus tylko przy pustym polu, żeby klawiatura nie zasłaniała poprzednich wyników.
  const onSearch = () => setState(state => ({
    ...state,
    active: {
      ...state.active,
      search: !state.active.search,
      input: !state.active.search && !state.search.input.trim()
    }
  }))

  return (
    <div className={styles.buttons}>
      <Button
        active={!active.search && input.chapter > 1}
        disabled={status == 'loading'}
        onClick={() => onChange(-1)}
        aria-label="Prev Chapter"
      >
        <ArrowLeft />
      </Button>
      <Button
        active={true}
        onClick={() => activeText ? onClick() : onSearch()}
        aria-label={activeText
          ? navigator.share
            ? 'Share Selected'
            : 'Copy Selected'
          : active.search
            ? 'Back to Reading'
            : 'Search'
        }
      >
        {activeText
          ? navigator.share
            ? <Share />
            : <Copy />
          : active.search
            ? <Book />
            : <Search />
        }
      </Button>
      <Button
        active={!active.search && input.chapter < chapters}
        disabled={status == 'loading'}
        onClick={() => onChange(+1)}
        aria-label="Next Chapter"
      >
        <ArrowRight />
      </Button>
    </div>
  )
}

export default Buttons
